import React from 'react';
import classNames from 'classnames';

import config from 'config';

import {resetPasswordClick} from '../../services/user/api';
import {handleChange} from "../../utils/ComponentUtilFunctions";
import { validateEmail } from '../../utils/General';
import PropTypes from "prop-types";
import {Link} from "react-router-dom";
import BlueButton from "../../components-new/buttons/BlueButton";


class ForgotPassword extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            email: '',
            disabled: false,
            error: {},
        };
        this.handleChange = handleChange.bind(this);
    }

    reset = (event) => {
        event.preventDefault();
        const {
            email, disabled,
        } = this.state;

        if (disabled) {
            return;
        }

        if (!this.validate()) {
            return;
        }

        this.setState({
            disabled: true,
        });

        const {addNotification} = this.props;



        resetPasswordClick(
            email,
        ).then(() => {
            addNotification('mailWasSent', config.notificationLevels.success);
        }).catch(() => {
            this.setState({
                disabled: false,
            });
            addNotification('passwordRecoveryError', config.notificationLevels.error);
        });
    };

    validate = () => {
        const {
            email
        } = this.state;

        const error = validateEmail(email);

        this.setState({error});

        return Object.keys(error).length === 0 && error.constructor === Object;
    };

    render() {
        const {email, error, disabled} = this.state;

        return (
            <div>
                <h1 style={{color: "#043e5c"}} className="form-header">
                    Password Recovery
                </h1>
                <p style={{margin: '20px 0', textAlign: 'center'}}>
                    Enter email the email address you used to register. We will send you instructions on how</p>
                <form onSubmit={(e) => {
                    e.preventDefault();
                    return false;
                }}>
                    <p className={classNames('form-element-label', 'required', { error: error.email })}>
                        {error.email ? error.email.message : 'Email' }
                    </p>
                    <input
                        type="text"
                        name={'email'}
                        className={classNames('form-element', { error: error.email })}
                        placeholder="Email"
                        value={email}
                        onChange={this.handleChange('email')}
                    />
                    <BlueButton styles={{marginBottom:'5px'}} type={'submit'} onClick={this.reset} children={'Send'}/>
                    <div style={{ textAlign: 'center' }}>
                        <Link to="/login" className="link">
                            <p className="link">
                                Sign-In
                            </p>
                        </Link>
                    </div>
                </form>

            </div>
        );
    }
}

ForgotPassword.propTypes = {
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    addNotification: PropTypes.func.isRequired,
};

export default ForgotPassword;


// WEBPACK FOOTER //
// ./src/scenes/auth/ForgotPassword.jsx